export enum NewsTagModifier {
  Orange = 'orange',
  Gray = 'gray',
  Green = 'green',
  Purple = 'purple',
}
